// @ts-ignore
import { CircleSlider } from "react-circle-slider";
import { PureComponent, ReactNode } from "react";
import CircularProgressBarStates, { CircularProgressBarProps } from "./CircularProgressBar.models";
import './CircularProgressBar.scss'


export default class CircularProgressBar extends PureComponent<CircularProgressBarProps, CircularProgressBarStates> {
    constructor(props: any) {
        super(props);
        this.state = {
            config: {
                size: 90,
                knobRadius: 10,
                progressWidth: 10,
                circleWidth: 10,
                progressColor: "#25b3c9",
                circleColor: "rgb(37 179 201 / 38%)",
                showTooltip: true,
                showPercentage: true,
                tooltipSize: 15,
                value: 0
            }
        };
    }

    consoleLog = (value: any) => {
        console.log(value);
    }

    handleChange = (value: any) => {
        this.props.onHandle(this.props.indexValue, value)
    };

    render(): ReactNode {
        let { config } = this.state
        let { value, label } = this.props
        return <>
            <div className={'area-circle-slider'}>
                <CircleSlider
                    value={value}
                    size={config.size}
                    knobRadius={config.knobRadius}
                    progressWidth={config.progressWidth}
                    circleWidth={config.circleWidth}
                    progressColor={config.progressColor}
                    circleColor={config.circleColor}
                    showTooltip={config.showTooltip}
                    showPercentage={config.showPercentage}
                    tooltipSize={config.tooltipSize}
                    onChange={this.handleChange}
                    
                />
                <div>{label}</div>
            </div>
        </>;
    }
}